import { Info } from '@components/icons'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

interface props {
  colour: string | null
}

const ProductColourWall: FC<props> = ({ colour }) => {
  const { t } = useTranslation('product')
  const { t: tcommon } = useTranslation('common')
  return (
    <>
      <div
        className="aspect-square w-full md:aspect-productImage"
        style={{ backgroundColor: colour || 'white' }}
      ></div>
      <div className="body-2 hidden pt-2 lg:flex">
        <div>{tcommon('actual-product-colour-shown')}</div>
        <div className="cursor-pointer pl-1">
          <div className="group relative flex flex-col items-center">
            <Info />
            <div className="absolute hidden w-[328px] items-center pt-4 group-hover:flex">
              <span className="body-2 relative rounded-sm bg-white p-3 text-xs leading-none shadow-[0_2px_4px_rgba(100,100,100,0.1)]">
                {t('product-chalk-desc')}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ProductColourWall
